export default __webpack_public_path__ + "static/national-2990993c35abcb199ef4c6643e0cd32d.mp4";